<template>
  <AppDialog v-model="dialog" width="1178">
    <template v-slot:activator="{attrs, on}">
      <span>
        {{ $tc('months',period.duration,{count: period.duration}) }}
        <button v-on="on" v-bind="attrs" class="dashboard-payment__change">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M5 14.5017V17.0017H7.5L14.8733 9.62833L12.3733 7.12833L5 14.5017ZM16.8067 7.695C17.0667 7.435 17.0667 7.015 16.8067 6.755L15.2467 5.195C14.9867 4.935 14.5667 4.935 14.3067 5.195L13.0867 6.415L15.5867 8.915L16.8067 7.695Z" fill="#0A82D9" />
          </svg>
        </button>
      </span>
    </template>
    <div class="plan-change-period">
      <PaymentDialogModalPeriods v-model="selected" v-if="plan" :plan="plan" />
      <div v-if="selected && selected.id !== period.id" class="plan-change-period__text">
        <div class="plan-change-period__text-top">
          {{ $t('text') }}
        </div>
        <div class="plan-change-period__text-item">
          <span class="plan-change-period__text-caption">
            {{ $t('nextPayment') }}:
          </span>
          <span class="plan-change-period__text-value">
            {{ nextPaymentText }}
          </span>
        </div>
        <div class="plan-change-period__text-item">
          <span class="plan-change-period__text-caption">
            {{ $t('total') }}{{ $tc('months',selected.duration,{count: selected.duration}) }}:
          </span>
          <span class="plan-change-period__text-value">
            <PaymentPeriodPrice :period="selected" :plan="plan" />
          </span>
        </div>
      </div>
      <AppWithLoading>
        <template v-slot:default="{loader}">
          <VBtn class="mr-2" @click="loader(() => save())" color="success">
            {{ $t('save') }}
          </VBtn>
          <VBtn outlined @click="dialog = false">
            {{ $t('cancel') }}
          </VBtn>
        </template>
      </AppWithLoading>
    </div>
  </AppDialog>
</template>

<script>
import useAccount from '@/compositions/accounting/useAccount';
import useChangePeriod from '@/compositions/accounting/useChangePeriod';
import { computed, ref } from '@vue/composition-api';
import usePlan from '@/compositions/accounting/usePlan';
import PaymentDialogPeriods from '@/components/Payment/Periods/PaymentDialogPeriods';
import PaymentPeriodPrice from '@/components/Payment/Periods/PaymentPeriodPrice';
import AppWithLoading from '@/components/AppWithLoading';
import AppDialog from '@/components/AppDialog';
import PaymentDialogModalPeriods from '@/components/Payment/Periods/PaymentDialogModalPeriods';

export default {
  name: 'PaymentPeriodChange',
  components: {
    PaymentDialogModalPeriods, AppDialog, AppWithLoading, PaymentPeriodPrice, PaymentDialogPeriods,
  },
  setup() {
    const {
      account, plan, nextPlan, nextPaymentText,
    } = useAccount();

    const selected = ref(null);
    const dialog = ref(null);

    const { fetchAll } = usePlan();
    fetchAll();
    const showChange = ref(false);

    const { changePeriod } = useChangePeriod();

    async function save() {
      await changePeriod(selected.value.id);
      dialog.value = false;
    }

    return {
      period: computed(() => account.value.next?.paymentPeriod || account.value.period),
      save,
      plan: computed(() => nextPlan.value || plan.value),
      showChange,
      nextPaymentText,
      selected,
      dialog,
    };
  },
};
</script>

<style lang="scss" scoped>
.dashboard-payment {
    &__value {
       margin-bottom: 0.625rem;
     }
    &__change {
       display: inline-block;
       width: 1.375rem;
       height: 1.375rem;
       vertical-align: middle;
     }
}
  .plan-change-period {
    padding: 1.875rem 1.875rem 3.75rem;
    background: #FFFFFF;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.04);
    border-radius: 0.625rem;
    text-align: center;
    &__text {
      font-size: 1.0625rem;
      font-weight: 400;
      line-height: 1.53;
      color: #091A35;
      margin-bottom: 2.5rem;
    }
    &__text-top {
      margin-bottom: 1.875rem;
    }
    &__text-item {
      width: 26rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      color: #212121;
      font-weight: 400;
      line-height: 1.375;
      margin: 0 auto 1.125rem auto;
      overflow: hidden;
      &:after {
        content: '';
        background: url("../../../assets/img/account/plan/dashboard-details-bg.svg") center;
        width: 100%;
        height: 1px;
        position: absolute;
        left: 0;
        bottom: 0.375rem;
        z-index: 1;
      }
    }
    &__text-caption, &__text-value {
      background: #FFFFFF;
      position: relative;
      z-index: 2;
    }
  }
@media #{map-get($display-breakpoints, 'lg-and-down')} {
  .plan-change-period {
    padding: 1.875rem 1.5rem 3rem;
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .plan-change-period {
    padding: 1.875rem 1rem;
    &__text {
      font-size: 1rem;
      margin-bottom: 2.5rem;
    }
    &__text-top {
      margin-bottom: 1.25rem;
    }
    &__text-item {
      width: 24rem;
      margin: 0 auto 0.875rem auto;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .plan-change-period {
    padding: 1.25rem 0.625rem;
    &__text {
      font-size: 0.8125rem;
      margin-bottom: 1.25rem;
    }
    &__text-top {
      margin-bottom: 0.75rem;
    }
    &__text-item {
      width: 100%;
      max-width: 20rem;
      margin: 0 auto 0.625rem auto;
    }
  }
}
</style>

<i18n lang="yml" locale="ru">
months: '{count} месяцев | {count} месяц | {count} месяца | {count} месяцев'
text: Изменение платежного периода повлияет на следующие списания
nextPayment: Следующий платеж
total: 'Итого '
save: Сохранить
cancel: Отмена
</i18n>
<i18n lang="yml" locale="en">
months: 'months | {count} month | {count} months'
text: Changes will affect your next payment
nextPayment: Next payment
total: 'Total '
save: Save
cancel: Cancel
</i18n>
